<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
</script>
<template>
  <div>
    <index-navbar/>
    <section
        class="header relative pt-16 items-center flex h-screen max-h-860-px"
    >
      <div class="container mx-auto items-center flex flex-wrap">
        <div class="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4">
          <div class="pt-32 sm:pt-0">
            <h1 class="font-semibold text-4xl text-blueGray-600">
              BPH
            </h1>
            <p class="mt-4 text-lg leading-relaxed text-blueGray-500" style="text-align: justify;font-size:18px">
              Integrating 141 self-sequencing datasets and 360 publicly available datasets of BPH, covering multiple
              research contexts including reproductive capacity, insecticide resistance, resistant rice interaction, and
              wing morph dimorphism, among which 69 were strand-specific libraries.
              A unified data processing pipeline PipeOne-NM was applied for quality control, transcriptome assembly,
              quantification, and functional annotation, resulting in a comprehensive gene expression resource for BPH.
            </p>
          </div>
        </div>
        <div class="w-full lg:w-6/12 xl:w-6/12 px-4">
          <img src="@/assets/pic/introduce.png" style="width: 80%">
        </div>
      </div>

    </section>

    <footer-component/>
  </div>
</template>
